/**
 * Constantes partagees client/serveur.
 *
 * ATTENTION : ce fichier est bundle dans le client, donc PUBLIC.
 * Tout ce qui doit rester secret (tables de gains, poids des rouleaux, RTP)
 * vit exclusivement dans packages/functions/src/games/**.
 */
/** Solde credite a la creation du compte. */
export const INITIAL_BALANCE = 1000;
/** Jetons offerts chaque jour (cumulables, aucun rachat possible). */
export const DAILY_GRANT = 1000;
/** Bornes de mise, verifiees cote serveur sur chaque action de jeu. */
export const BET_MIN = 1;
export const BET_MAX = 1000;
/** Intervalle minimal entre deux actions de jeu d'un meme joueur (anti-spam clic). */
export const RATE_LIMIT_MS = 300;
/** Longueur max d'une graine client choisie par le joueur. */
export const CLIENT_SEED_MAX_LENGTH = 64;
/** Duree de validite du JWT de session emis par /api/token. */
export const SESSION_TTL_MS = 24 * 60 * 60 * 1000;
/** Anti-addiction : rappel de pause apres 30 min de jeu continu. */
export const SESSION_REMINDER_MS = 30 * 60 * 1000;
/** Anti-addiction : une session est consideree interrompue apres 5 min d'inactivite. */
export const SESSION_IDLE_RESET_MS = 5 * 60 * 1000;
/** Identifiants de jeu. */
export const GAME_IDS = ['slots', 'blackjack', 'roulette', 'poker'];
//# sourceMappingURL=constants.js.map